{
	"title": "Rechnungen",
	"buttonShowMoreInvoicesTitle": "Mehr Rechnungen anzeigen",
	"invoicesTableHeaders": {
		"date": "Datum",
		"invoiceNumber": "Rechnungsnummer",
		"deliveredQuantity": "Gelieferte Menge",
		"bundledCarbonSavings": "Gebündelte Kohlenstoffeinsparungen",
		"transactionId": "Transaktions-ID"
	},
	"errorMessage": "Rechnungen konnten nicht geladen werden"
}
